import { collection, doc, getDoc, getDocs, orderBy, query, serverTimestamp, setDoc, updateDoc } from "firebase/firestore"
import { auth, db } from "../config/firebase"
import { MAOLAM_APPROVED, MAOLAM_NONE, MAOLAM_REJECTED, MAOLAM_WAITING } from "./spName"


export const AddMaolamUser = async (uid = auth.currentUser.uid) => {
    try {
        await setDoc(doc(db, 'maolams', uid), {
            timestamp : serverTimestamp(),
            uid : uid,
            status : MAOLAM_WAITING,
            approver : "",
            reason : "",
            note : "",
            round : 0,
        })
    }
    catch (e) {
        alert(e.message)
    }
}

export const UpdateMaolamUser = async (uid, data) => {
    try {
        await updateDoc(doc(db, 'maolams', uid), { ...data })
    }
    catch (e) {
        alert(e.message)
    }
}

export const QueryOwnMaolam = async (uid = auth.currentUser.uid) => {
    try {
        const docRef = doc(db, 'maolams', uid)
        const docSnap = await getDoc(docRef)
        if (!docSnap.exists()) {
            const userRef = doc(db, 'users', uid)
            const userSnap = await getDoc(userRef)
            return {
                status : userSnap.data().register ? MAOLAM_APPROVED : MAOLAM_NONE
            }
        } 
        else {
            const { timestamp, status, reason } = docSnap.data()
            let ms = timestamp ? timestamp.seconds * 1000 : null
            const dateString = new Date(ms).toLocaleString('th')
            let a = { status, dateString, reason }
            return a
        }
        
    }
    catch (e) {
        alert(e.message)
    }
}

export const QueryAllMaolam = async () => {
    try {
        let a = {}
        let a1 = {}
        let a2 = {}
        let a3 = {}
        const q = query(collection(db, "maolams"), orderBy('timestamp', 'asc'))
        const docs = await getDocs(q)
        docs.forEach(d => {
            const { timestamp, status, approver, reason, note } = d.data()
            const ms = timestamp.seconds * 1000
            const dateString = new Date(ms).toLocaleString('th')
            a = { ...a, [d.id] : {status, ms, dateString, approver, reason, note, uid : d.id } }
        })
        let ida = Object.keys(a)
        for (let i = 0; i < ida.length; i++) {
            let d = a[ida[i]]
            const userRef = doc(db, 'users', ida[i])
            const userSnap = await getDoc(userRef)
            switch (d.status) {
                case MAOLAM_NONE: default:
                    break;
                case MAOLAM_WAITING:
                    a1 = { ...a1, [ida[i]] : {...a[ida[i]], ...userSnap.data()} }
                    break;
                case MAOLAM_REJECTED:
                    a2 = { ...a2, [ida[i]] : {...a[ida[i]], ...userSnap.data()} }
                    break;
                case MAOLAM_APPROVED:
                    a3 = { ...a3, [ida[i]] : {...a[ida[i]], ...userSnap.data()} }
                    break;
            }
        }
        return {
            waiting : a1,
            rejected : a2,
            approved : a3,
        }
    }
    catch (e) {
        alert(e.message)
    }
}